import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  type = 'website',
  image = 'https://www.navigatingminds.com.au/images/hero-background.png',
  url
}) => {
  const siteTitle = 'Navigating Minds Psychology';
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const siteUrl = 'https://www.navigatingminds.com.au';
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph Tags */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content={siteTitle} />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Structured Data - Enhanced Medical Business Schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': ['MedicalBusiness', 'Psychologist'],
          'name': 'Navigating Minds Psychology',
          'description': description,
          'url': siteUrl,
          'telephone': '+61 7 2150 3636',
          'email': 'admin@navigatingminds.com.au',
          'address': {
            '@type': 'PostalAddress',
            'addressCountry': 'AU',
            'addressRegion': 'Australia'
          },
          'medicalSpecialty': 'Psychology',
          'priceRange': '$$',
          'serviceType': ['Psychology Services', 'ASD Assessment', 'ADHD Assessment', 'Telehealth Therapy'],
          'areaServed': {
            '@type': 'Country',
            'name': 'Australia'
          },
          'availableChannel': {
            '@type': 'ServiceChannel',
            'serviceType': 'Telehealth',
            'availableLanguage': 'English'
          },
          'makesOffer': [
            {
              '@type': 'Offer',
              'itemOffered': {
                '@type': 'Service',
                'name': 'ASD Assessment',
                'description': 'Comprehensive Autism Spectrum Disorder assessment via telehealth'
              }
            },
            {
              '@type': 'Offer',
              'itemOffered': {
                '@type': 'Service',
                'name': 'ADHD Assessment',
                'description': 'Comprehensive ADHD assessment for adults and children via telehealth'
              }
            },
            {
              '@type': 'Offer',
              'itemOffered': {
                '@type': 'Service',
                'name': 'Telehealth Therapy',
                'description': 'Evidence-based online psychology therapy sessions'
              }
            }
          ],
          'openingHoursSpecification': {
            '@type': 'OpeningHoursSpecification',
            'dayOfWeek': ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            'opens': '09:00',
            'closes': '17:00'
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEO;